import { DotNetType } from 'libs/shared/src/models/basic/dotnet';

export interface IMethod {
  headers: any;
  method: MethodType;
  parameters: IMethodParameter[];
  return: MethodReturnType;
  url: string;
}

export interface IMethodParameter {
  name: string;
  type: DotNetType;
  isNullable?: boolean;
}

export enum MethodType {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete'
}

export type MethodReturnType = DotNetType;
